import Line from "../components/Line";
import NavBar from "../components/NavBar";
import {PageWrapper} from "../components/PageWrapper";
import {Main} from "../components/Main";
import Footer from "../components/Footer";
import styled from "styled-components";
import SiteHeader from "../components/SiteHeader";
import {MainBody} from "../components/MainBody";
import ImageSlider from "../components/ImageSlider";
import {AllCaps} from "../components/AllCaps";


export default function AboutUs() {

    const image = "/images/b6.png"

    return (
        <PageWrapper>
            <SiteHeader caption={"Kontakt"}/>
            <NavBar/>
            <MainBody>
                <Main>
                    <ImageSlider small/>
                    <AllCaps>
                        <Heading>Unsere Leistungen & Arbeitsweise</Heading>
                        {/*<Subheading>Ihr Partner für Tiefbau und Glasfaser in ganz Deutschland</Subheading>*/}
                    </AllCaps>
                    <ContentWrapper>
                        <TextSection>
                            <Paragraph>
                                <AllCaps>
                                    <strong>Unsere Leistungen & Arbeitsweise</strong>
                                </AllCaps>
                            </Paragraph>

                            <Paragraph>
                                Kompetenz und Erfahrung im Tiefbau – Bei der <strong>DaFa Rhein Sieg
                                GmbH</strong> bieten wir Ihnen umfassende Leistungen im Bereich Tiefbau, die auf über
                                einem Jahrzehnt Erfahrung basieren. Seit unserer Gründung im Jahr 2011 haben wir unser
                                Know-how stetig erweitert. Im Jahr 2021 haben wir uns entschieden, unsere Expertise auf
                                den Tiefbau zu konzentrieren, und uns insbesondere auf die Glasfaserverlegung zu
                                spezialisieren.
                            </Paragraph>

                            <BulletList>
                                <BulletItem>
                                    <BulletPoint>✔</BulletPoint>
                                    <span>
                                        <AllCaps>
            <strong>Meisterliche Führung:</strong>
                                        </AllCaps>Unser Team wird durch einen Meister im Tiefbau geleitet. Dies sichert nicht nur eine fachkundige Planung und Ausführung, sondern auch die Einhaltung höchster Qualitätsstandards bei jedem Projekt.
        </span>
                                </BulletItem>

                                <BulletItem>
                                    <BulletPoint>✔</BulletPoint>
                                    <span>
                                        <AllCaps>
            <strong>Ein eingespieltes Team:</strong> </AllCaps>Jedes Mitglied bringt umfassende Kenntnisse im Tiefbau und in der Glasfaserverlegung mit und arbeitet zielorientiert zusammen, um optimale Ergebnisse zu erzielen.
        </span>
                                </BulletItem>

                                <BulletItem>
                                    <BulletPoint>✔</BulletPoint>
                                    <span>
                                             <AllCaps>
            <strong>Umfassende Expertise:</strong> </AllCaps>Von der Trassenplanung bis zur finalen Verlegung – wir meistern jede Herausforderung im Tiefbau und in der Glasfaserverlegung.
        </span>
                                </BulletItem>

                                <BulletItem>
                                    <BulletPoint>✔</BulletPoint>
                                    <span>
                                             <AllCaps>
            <strong>Selbstständige und effiziente Arbeitsweise:</strong></AllCaps> Unser Team arbeitet eigenverantwortlich und effizient – inklusive moderner Maschinentechnik und professioneller Antragsverwaltung.
        </span>
                                </BulletItem>

                                <BulletItem>
                                    <BulletPoint>✔</BulletPoint>
                                    <span>
                                        <AllCaps>
            <strong>Deutschlandweite Präsenz:</strong> </AllCaps>Egal, wo Ihr Projekt angesiedelt ist – wir bringen unsere Expertise direkt zu Ihnen.
        </span>
                                </BulletItem>
                            </BulletList>

                            <Paragraph>
                                Wir sind Ihr verlässlicher Partner für Infrastrukturprojekte, die Präzision, Fachwissen
                                und eine effiziente Umsetzung erfordern.
                            </Paragraph>

                        </TextSection>

                        <ImageSection>
                            {/* Platzhalter für ein Bild */}
                            <img className="image" src={image}
                                 alt={<ImagePlaceholder>Bild kommt hier hin</ImagePlaceholder>}/>
                        </ImageSection>
                    </ContentWrapper>

                </Main>
            </MainBody>
            <Line/>
            <Footer/>
        </PageWrapper>
    );
}

const Heading = styled.h2`
    font-size: 2.5rem;
    color: #1a202c;
    margin-bottom: 1rem;
    font-weight: 700;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        flex-direction: row;
        gap: 2rem;
    }
`;

const TextSection = styled.div`
    flex: 2;
`;

const Paragraph = styled.p`
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 1rem;
    text-align: justify;
`;

const ImageSection = styled.div`
    flex: 1;
    margin-top: 2rem;
    max-width: 400px;
    height: auto;

    .image {
        width: 100%;
        height: auto;
    }

    @media (min-width: 768px) {
        margin-top: 0;
    }
`;

const ImagePlaceholder = styled.div`
    width: 100%;
    height: 240px;
    background-color: #e2e8f0;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #718096;
    font-size: 1rem;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.03);
    transition: all 0.3s ease;

    &:hover {
        background-color: #cbd5e0;
        a
        color: #2d3748;
    }
`;

const BulletList = styled.ul`
    list-style: none;
    padding-left: 0;
    margin: 1rem 0;
`;

const BulletItem = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 1rem;
`;

const BulletPoint = styled.span`
    color: #FFDA2A;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.5;
    flex-shrink: 0;
`;

